import React from 'react';
import Layout from '../components/layout/Layout';
import SEO from '../components/shared/SEO';
import ContactForm from '../components/shared/ContactForm';
import NewsletterSignup from '../components/shared/NewsletterSignup';

const ContactPage = () => {
  return (
    <Layout>
      <SEO
        title="Contact Us"
        description="Get in touch with the SummaryGPT team. We'd love to hear from you."
        path="/contact"
      />

      <section className="relative min-h-screen flex items-center pt-24 pb-20 overflow-hidden">
        <div className="absolute inset-0 sgpt-glow opacity-60 pointer-events-none" />
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
            <div>
              <ContactForm />
            </div>
            
            <div className="lg:pt-16">
              <div className="glass-card rounded-2xl p-8 lg:p-10">
                <NewsletterSignup />
              </div>
              
              <div className="mt-10 glass-card rounded-2xl p-8">
                <h3 className="text-xl font-bold text-white mb-4">Other ways to reach us</h3>
                <div className="space-y-4 text-slate-400">
                  <p>
                    <span className="text-slate-500 block text-sm mb-1">Email</span>
                    <a href="mailto:developer@summarygpt.com" className="text-amber-400 hover:text-amber-300 transition-colors">
                      developer@summarygpt.com
                    </a>
                  </p>
                  <p>
                    <span className="text-slate-500 block text-sm mb-1">Response time</span>
                    Usually within 24-48 hours
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ContactPage;
